import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from "../../../actions/api";
import DispenserFormData from "./DispenserFormData.js";
import Constants from "../../../services/Constants";
import { getARVFacilityList } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


const AddDispenser = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "dispenser";
  const FacilityId=localStorage.getItem('FacilityId');
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;
  //const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getARVFacilityList(); 

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState(
    ''
  ); 

  const [generatedNumber, setgeneratedNumber] = useState(
    ''
  ); 


  let params={"menukey": "dispenser", "FacilityId":FacilityId,  "TransactionTypeId":'', "Page":'Dispenser', TransactionDate: ''};
  const { data:invoiceNo } = useQuery([params], api.getInvoiceNo, 
    {onSuccess: (data) => { 
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["number"] = data; 
      setFormData(fdata); 

    } ,
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
  }
    );


  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    initial: "",
    title: "",
    rxLevel: "",
    number: generatedNumber,
    professional: "",
    staff: "",
    post: "",
    demander: "",
    active: false,
    address1: "",
    contactNumber: "",
    contactNumberEmergency: "",
    city: "",
    emailWork: "",
    country: "",
    emailPersonal: "",
    UserId: "",
  });
  const [errorObject, setErrorObject] = useState({});
  const [pricebesideLevel, setPricebesideLevel] = useState(null);
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(
    ["dispenser", id],
    () =>
      api.getDispenser(id).then((res) => {
        setFormData(res.data);
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.saveDispenser, {
    onSuccess: (data) => {

      if (data.status == 200) {
        localStorage.setItem(
          "UserList",
          JSON.stringify(data.userlist)
        );
      
      if(FacilityId == data.FacilityId){
          api.getFacilityListNotEqual99ANDSuppliers('DispenserList', data.FacilityId).then((response) => {
            localStorage.setItem(
              "DispenserList",
              JSON.stringify(response.datalist.DispenserList)
            );
          })
      }
      
        queryClient.getQueriesData("dispenser");
        props.history.push("/dispenser");

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
   
    data[name] = value;
    if(name=="demander"){
    for(let i=0; i<FacilityList.length; i++){
     
      if(value==FacilityList[i].id){

      setgeneratedNumber(FacilityList[i].FacilityCode);//
      data["number"]="D-"+FacilityList[i].FacilityCode+"-"+generatedInvoiceNo;
      setFormData(data);
      

      //setgeneratedNumber(FacilityList[i].FacilityCode+generatedInvoiceNo);
      
      //let fdata = { ...formData }; 
      //fdata["number"] = data; 

      }
       
    }
    }else 
    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      lastName: "",
      firstName: "",
      initial: "",
      title: "",
      rxLevel: "",
      number: "",
      professional: "",
      staff: "",
      post: "",
      demander: "",
      active: false,
      address1: "",
      contactNumber: "",
      contactNumberEmergency: "",
      city: "",
      emailWork: "",
      country: "",
      emailPersonal: "",
      UserId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["lastName", "firstName", "rxLevel", "number","demander"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {

    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
    }
  };

      //====== Start Choosen Dropdown===========
      const handleChangeChoosenProps = (name, value) => {
        let data = { ...formData };
        data[name] = value;   
        setFormData(data); 
        setErrorObject({ ...errorObject, [name]: "" });
          
      }
      //====== End Choosen Dropdown===========

  return (
    <>
      <DispenserFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        handleChangeChoosenProps={handleChangeChoosenProps}
        {...props}
      />
    </>
  );
};

export default AddDispenser;
